import { render } from "./x-tool-tip.vue?vue&type=template&id=02388ef8&scoped=true"
import script from "./x-tool-tip.vue?vue&type=script&lang=js"
export * from "./x-tool-tip.vue?vue&type=script&lang=js"

import "./x-tool-tip.vue?vue&type=style&index=0&id=02388ef8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02388ef8"]])

export default __exports__